import React, { useState } from 'react';
import DownArrow from './../../assets/images/down-arrow.svg';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import { UserDetails } from '../../models/UserDetails';

interface CurrencySelectorProps {
  currency: string;
  curList: string[];
  userDetails?: UserDetails;
  dynamicTextColors?: any;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({ currency, curList, userDetails, dynamicTextColors }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(currency);

  const currencies = ['INR','USD', 'EUR', 'GBP', 'JPY'];

  // Get dynamic text color class from Redux instead of calling function
  const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleCurrencySelect = (curr: string) => {
    setSelectedCurrency(curr);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        // onClick={toggleDropdown}
        className={`flex items-center justify-between px-3 py-2 w-full text-xs font-medium whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-slate-800 ${inputBoxTextColorClass}`}
      >
        <span className={inputBoxTextColorClass}>{selectedCurrency}</span>
        {/* <img
          loading="lazy"
          src={DownArrow}
          alt=""
          className="shrink-0 ml-8 w-2.5 aspect-[1.67]"
        /> */}
      </button>
      {isOpen && (
        <ul className={`absolute z-10 w-full mt-1 bg-inputbox-color border border-slate-800 rounded-lg shadow-lg ${inputBoxTextColorClass}`}>
          {curList?.map((curr) => (
            <li
              key={curr}
              onClick={() => handleCurrencySelect(curr)}
              className={`px-3 py-2 text-xs hover:bg-zinc-700 cursor-pointer ${inputBoxTextColorClass}`}
            >
              {curr}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    userDetails: state.userDetails?.userDetails,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
  };
};

export default connect(mapStateToProps)(CurrencySelector);